module.exports = __webpack_public_path__ + "img/book.4401461e.png";